import { render, staticRenderFns } from "./EmergencyNumbersPage.vue?vue&type=template&id=383308e2&"
import script from "./EmergencyNumbersPage.vue?vue&type=script&lang=js&"
export * from "./EmergencyNumbersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports